import { Show, createEffect, createSignal } from "solid-js";
import STModal from "../st-modal/st-modal";
import CopyWizard from "./copy-wizard";
import { useReportBrowser } from "./report-browser-context";

export default function CopyDialog() {
  const reportBrowser = useReportBrowser()
  const [isOpen, setIsOpen] = createSignal(reportBrowser.state.isCopyDialogOpen)
  
  createEffect(() => { setIsOpen(reportBrowser.state.isCopyDialogOpen) })

  createEffect(() => {
    if (isOpen() !== reportBrowser.state.isCopyDialogOpen) {
      if (isOpen() === false) {
        reportBrowser.cancelCopy()
      }
    }
  })

  return (
    <Show when={reportBrowser.selectedReport()}>
      <STModal show={[isOpen, setIsOpen]}>
          <CopyWizard report={reportBrowser.selectedReport()!} isCopying={[isOpen, setIsOpen]}></CopyWizard>
      </STModal>
    </Show>
  )
}